export default [
  // {
  //   path: '/add-route',
  //   name: 'add-route',
  //   component: () => import('@/views/pages/routes/AddRoute.vue'),
  //   meta: {
  //     resource: 'Routes',
  //     action: 'read',
  //     pageTitle: 'Add Route',
  //     breadcrumb: [
  //       {
  //         text: 'Add Route',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/:locale/terms-of-service',
    name: 'terms-of-service',
    component: () => import('@/views/pages/legal/TermsOfService.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/:locale/refund-policy',
    name: 'refund-policy',
    component: () => import('@/views/pages/legal/RefundPolicy.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/:locale/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/pages/legal/PrivacyPolicy.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@/views/pages/authentication/Auth.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/login-v1',
    name: 'auth-login-v1',
    component: () => import('@/views/pages/authentication/Login-v1.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/login-v2',
    name: 'auth-login-v2',
    component: () => import('@/views/pages/authentication/Login-v2.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/register-v1',
    name: 'auth-register-v1',
    component: () => import('@/views/pages/authentication/Register-v1.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/register-v2',
    name: 'auth-register-v2',
    component: () => import('@/views/pages/authentication/Register-v2.vue'),
    meta: {
      layout: 'full',
    },
  },
  // {
  //   path: '/forgot-password',
  //   name: 'auth-forgot-password',
  //   component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
  //   meta: {
  //     layout: 'full',
  //     resource: 'Auth',
  //     redirectIfLoggedIn: true,
  //   },
  // },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPasswordEmail.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/forgot-password-v2',
    name: 'auth-forgot-password-v2',
    component: () => import('@/views/pages/authentication/ForgotPassword-v2.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/reset-password-v1',
    name: 'auth-reset-password-v1',
    component: () => import('@/views/pages/authentication/ResetPassword-v1.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/reset-password-v2',
    name: 'auth-reset-password-v2',
    component: () => import('@/views/pages/authentication/ResetPassword-v2.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      resource: 'Account',
      action: 'update',
      pageTitle: 'Account',
      breadcrumb: [
        {
          text: 'Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/service/provider/:id',
    name: 'pages-profile-service-provider',
    component: () => import('@/views/pages/profile/ServiceProviderProfile.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      pageTitle: 'Contractor',
      breadcrumb: [
        /*  {
          text: 'List',
          to: { name: 'apps-user-service-providers-list' },
        }, */
        {
          text: 'Info',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => import('@/views/pages/profile/Profile.vue'),
    meta: {
      resource: 'Account',
      action: 'update',
      pageTitle: 'Account',
    },
  },

  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/views/pages/faq/Faq.vue'),
    meta: {
      resource: 'Auth',
      pageTitle: "FAQ's",
    },
  },
  {
    path: '/pages/knowledge-base',
    name: 'pages-knowledge-base',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBase.vue'),
    meta: {
      pageTitle: 'Knowledge Base',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base/:category',
    name: 'pages-knowledge-base-category',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBaseCategory.vue'),
    meta: {
      pageTitle: 'Category',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pages/knowledge-base/:category/:slug',
    name: 'pages-knowledge-base-question',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBaseCategoryQuestion.vue'),
    meta: {
      pageTitle: 'Question',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          to: '/pages/Knowledge-base/category',
        },
        {
          text: 'Question',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('@/views/pages/landing/LandingPricing.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/donates',
    name: 'donates-checkout',
    component: () => import('@/views/pages/donates/DonateCheckout.vue'),
    meta: {
      pageTitle: 'donate.checkout_title',
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        {
          text: 'donate.details_title',
        },
      ],
    },
  },
  {
    path: '/donates/result',
    name: 'donates-result',
    component: () => import('@/views/pages/donates/DonateCheckoutResult.vue'),
    meta: {
      pageTitle: 'donate.default_donation_purpose',
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        {
          text: 'donate.details_title',
        },
      ],
    },
  },
  // {
  //   path: '/pages/pricing',
  //   name: 'pages-pricing',
  //   component: () => import('@/views/pages/pricing/Pricing.vue'),
  // },
  // {
  //   path: '/pages/blog/list',
  //   name: 'pages-blog-list',
  //   component: () => import('@/views/pages/blog/BlogList.vue'),
  //   meta: {
  //     pageTitle: 'Blog List',
  //     breadcrumb: [
  //       {
  //         text: 'Pages',
  //       },
  //       {
  //         text: 'Blog',
  //       },
  //       {
  //         text: 'List',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/pages/blog/:id',
  //   name: 'pages-blog-detail',
  //   component: () => import('@/views/pages/blog/BlogDetail.vue'),
  //   meta: {
  //     pageTitle: 'Blog Detail',
  //     breadcrumb: [
  //       {
  //         text: 'Pages',
  //       },
  //       {
  //         text: 'Blog',
  //       },
  //       {
  //         text: 'Detail',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/pages/blog/edit/:id',
  //   name: 'pages-blog-edit',
  //   component: () => import('@/views/pages/blog/BlogEdit.vue'),
  //   meta: {
  //     pageTitle: 'Blog Edit',
  //     breadcrumb: [
  //       {
  //         text: 'Pages',
  //       },
  //       {
  //         text: 'Blog',
  //       },
  //       {
  //         text: 'Edit',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/',
    name: 'pages-landing',
    component: () => import('@/views/pages/landing/Landing.vue'),
    meta: {
      resource: 'Auth',
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/promo',
    name: 'promo',
    component: () => import('@/views/pages/promo/Promo.vue'),
    meta: {
      pageTitle: 'Promo',
      resource: 'ReferralCode',
      action: 'create',
    },
  },
  {
    path: '/promo/referrals',
    name: 'promo-referrals',
    component: () => import('@/views/pages/promo/PromoReferrals.vue'),
    meta: {
      pageTitle: 'referral.referrals',
      resource: 'Referral',
      action: 'create',
      contentRenderer: 'sidebar-left-detached',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'referral.referrals',
          to: '/promo/referrals',
        },
      ],
    },
  },
  {
    path: '/promo/referral/links',
    name: 'promo-referral-links',
    component: () => import('@/views/pages/promo/PromoReferralLinks.vue'),
    meta: {
      pageTitle: 'referral.referral_links',
      resource: 'ReferralCode',
      action: 'create',
      icon: 'MessageSquareIcon',
      breadcrumb: [
        {
          text: 'referral.referral_links',
          to: '/promo/referral/links',
        },
      ],
    },
  },
  {
    path: '/promo/print',
    name: 'promo-print',
    component: () => import('@/views/pages/promo/PromoPrint.vue'),
    meta: {
      pageTitle: 'common.print',
      resource: 'ServiceOffer',
      action: 'read',
    },
  },
  {
    path: '/referral/:id',
    name: 'pages-profile-referral',
    component: () => import('@/views/pages/profile/ReferralProfile.vue'),
    meta: {
      resource: 'Referral',
      action: 'create',
      pageTitle: 'referral.referral',
      breadcrumb: [
        {
          text: 'List',
          to: '/promo/referrals',
        },
      ],
    },
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('@/views/pages/analytic/Analytic.vue'),
    meta: {
      pageTitle: 'Analytics',
      resource: 'ServiceOffer',
      action: 'read',
    },
  },
  {
    path: '/our-mission',
    name: 'our-mission',
    component: () => import('@/views/pages/miscellaneous/OurMission.vue'),
    meta: {
      resource: 'Auth',
      pageTitle: 'Our Mission',
    },
  },
]
